import { render, staticRenderFns } from "./rappi_location_modal.vue?vue&type=template&id=487bbe8a&scoped=true&"
import script from "./rappi_location_modal.vue?vue&type=script&lang=js&"
export * from "./rappi_location_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487bbe8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('487bbe8a')) {
      api.createRecord('487bbe8a', component.options)
    } else {
      api.reload('487bbe8a', component.options)
    }
    module.hot.accept("./rappi_location_modal.vue?vue&type=template&id=487bbe8a&scoped=true&", function () {
      api.rerender('487bbe8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/rappi/location/rappi_location_modal.vue"
export default component.exports